@if (!isAcceptanceMode) {
  <div class="privacy-shell">
    <div class="privacy-topbar">
      @if (isLoggedIn) {
        <a routerLink="/home" class="privacy-back-link">
          <i class="ri-arrow-left-line"></i>
          <img src="assets/images/tmeic_logo_inverted.svg" alt="TMEIC" class="privacy-logo" />
        </a>
      } @else {
        <img src="assets/images/tmeic_logo_inverted.svg" alt="TMEIC" class="privacy-logo" />
      }

      <div class="privacy-topbar-actions">
        <a routerLink="/support" class="privacy-nav-btn">Support</a>
        @if (!isLoggedIn) {
          <a routerLink="/login" class="privacy-nav-btn">Login</a>
        }
      </div>
    </div>

    <div class="privacy-public-content">
      <div class="privacy-public-page">
        <div class="privacy-public-header">
          <div>
            <h1>Navigator Privacy Policy</h1>
            @if (policy) {
              <p>Version {{ policy.versionNumber }}</p>
            }
          </div>
        </div>

        @if (loading) {
          <div class="privacy-state">
            <i class="ri-loader-4-line spin"></i>
            Loading privacy policy...
          </div>
        }

        @if (!loading && errorMessage) {
          <div class="privacy-error">{{ errorMessage }}</div>
        }

        @if (!loading && policy) {
          <section class="privacy-public-card">
            <div class="privacy-public-body ql-snow">
              <div class="ql-editor" [innerHTML]="policyHtml"></div>
            </div>
          </section>
        }
      </div>
    </div>
  </div>
} @else {
<div class="privacy-page">
  <div class="privacy-card">
    <div class="privacy-header">
      <img src="assets/images/tmeic-logo-tagline.png" alt="TMEIC" />
      <div>
        <h1>Navigator Privacy Policy</h1>
        @if (policy) {
          <p>Version {{ policy.versionNumber }}</p>
        }
      </div>
    </div>

    @if (loading) {
      <div class="privacy-state">
        <i class="ri-loader-4-line spin"></i>
        Loading privacy policy...
      </div>
    }

    @if (!loading && errorMessage) {
      <div class="privacy-error">{{ errorMessage }}</div>
    }

    @if (!loading && policy) {
      <div #policyContent class="privacy-content ql-snow" (scroll)="onPolicyScroll($event)">
        <div class="ql-editor" [innerHTML]="policyHtml"></div>
      </div>

      @if (isAcceptanceMode) {
        <div class="privacy-consent-footer">
          <div class="privacy-note">
            You must scroll to the end of this policy before agreeing.
          </div>

          <div class="privacy-actions">
            <button type="button" class="btn-secondary" (click)="decline()" [disabled]="saving">
              Decline
            </button>
            <button type="button" class="btn-primary" (click)="accept()" [disabled]="saving || !hasScrolledToEnd">
              {{ saving ? 'Saving...' : 'Agree' }}
            </button>
          </div>
        </div>
      }
    }
  </div>
</div>
}
